import { apiPasswordUpdate } from '../services';
export async function updatePassword(password, token) {
    const response = await apiPasswordUpdate(password, token);
    return formatResponse(response);
}
function formatResponse({ success, error }) {
    if (!success) {
        return { success: false, error };
    }
    return { success: true };
}
